:host {
  display: block;
}

.biel-header {
  align-items: flex-start;
  display: flex;
  color: var(--biel-header-text-color);
  justify-content: space-between;
}


.biel-header__title {
  font-size: var(--biel-header-font-size);
  font-weight: var(--biel-header-font-weight);
}

.biel-header__powered-by:not(:empty) {
  color: var(--biel-header-powered-by-text-color);
  padding-top: 5px;
  font-size: 14px;
  height: 12px;
}

.biel-header__powered-by a {
  color: var(--biel-header-powered-by-link-color);
  font-weight: 500;
  text-decoration: none;
}

.biel-header__icons {
  display: flex;
  justify-content: flex-end;
}

.biel-header__icon {
  color: var(--biel-header-text-color);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 2px;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  position: relative;
}

.biel-header__icon:hover {
  opacity: 0.7;
}

.biel-header__icon--active {
  background-color: var(--biel-primary-color);
  border-radius: 4px;
}

.biel-header__icon--active svg {
  stroke: var(--biel-white-color);
}

.biel-header__icon--active:hover {
  opacity: 1;
  background-color: var(--biel-primary-hover-color);
}

.biel-header__tooltip {
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 1000;
}

.biel-header__tooltip::before {
  content: '';
  position: absolute;
  top: -3px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #333;
}

.biel-header__icon:hover .biel-header__tooltip {
  opacity: 1;
}

.biel-header__settings-container {
  position: relative;
  display: inline-block;
}

.biel-header__settings-dropdown {
  position: absolute;
  top: 38px;
  right: 0;
  background: var(--biel-dropdown-bg-color);
  border: 1px solid var(--biel-dropdown-border-color);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 240px;
  z-index: 1000;
  overflow: hidden;
  animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.biel-header__dropdown-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
  border-bottom: 1px solid var(--biel-dropdown-border-color);
}

.biel-header__dropdown-item:last-child {
  border-bottom: none;
}

.biel-header__dropdown-item:hover {
  background-color: var(--biel-dropdown-hover-bg-color);
}

.biel-header__dropdown-item--selected {
  background-color: var(--biel-dropdown-selected-bg-color);
}

.biel-header__dropdown-item--selected:hover {
  background-color: var(--biel-dropdown-selected-hover-bg-color);
}

.biel-header__dropdown-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--biel-dropdown-text-color);
  margin-bottom: 2px;
}

.biel-header__dropdown-description {
  font-size: 12px;
  color: var(--biel-dropdown-text-secondary-color);
}
